import { render, staticRenderFns } from "./hall.vue?vue&type=template&id=6df48d5a"
import script from "./hall.vue?vue&type=script&lang=js"
export * from "./hall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports